import {firestoreDB} from "@/views/firebase";
import ApplicationModel from "@/models/application.model";

export default class ApplicationService{

    /**
     *
     * @returns {Promise<ApplicationModel[]>}
     */
    async getApplications(){
        const snapshots = await firestoreDB
            .collection('application')
            .orderBy('dateCreated', 'desc')
            .get();
        return snapshots.docs.map(doc=>ApplicationModel.fromFirestore(doc))
    }

    /**
     *
     * @param {ApplicationModel} application
     * @returns {Promise<void>}
     */
    async updateApplication(application){
        await firestoreDB
            .collection('application')
            .doc(application.id)
            .update(application.toJSON())
    }
}